import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import { CustomInputArea } from '../CustomInputArea';

export const DeleteTurnForm = ({ action }) => {

    const classes = useStyles();
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form className={classes.form} onSubmit={handleSubmit(action)}>
            <Controller
                name="observacion"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                    <CustomInputArea
                        label="Observación"
                        placeholder="Motivo de eliminación"
                        onChange={onChange}
                        value={value}   
                        error={errors.observacion}
                    />
                )}
                rules={{
                    required: "* La observación es requerida",
                    pattern: {
                        value: /^[\S].*[\S]$/,
                        message: "* La observación no es correcta",
                    },
                }}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                    type="submit" 
                    size="small"
                    variant="outlined"
                    color="error"
                    className={ classes.successButton }
                >
                    Eliminar
                </Button>
            </div>
        </form>
    );
}

const useStyles = makeStyles({
    form: {
        padding: 20,
        position: 'relative',
        width: 500
    },
    successButton: {
        color: '#fff !important',
        background: '#d32f2f !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#d32f2f !important',
            background: '#fff !important',
            borderColor: '#d32f2f !important'
        }
    }
});